import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['date', 'day', 'type'];

  connect() {
    this.switch({ target: this.typeTarget });
  }

  // action="change->switch-expire-fields#switch"
  switch({ target }) {
    switch (target.value) {
      case 'first': {
        this.#enable(this.dayTarget);
        this.#disable(this.dateTarget);
        break;
      }
      case 'date': {
        this.#disable(this.dayTarget);
        this.#enable(this.dateTarget);
        break;
      }
      default: {
        // none
        this.#disable(this.dayTarget);
        this.#disable(this.dateTarget);
        break;
      }
    }
  }

  #enable(field) {
    field.style.display = 'block';
    field.querySelector('input, select').disabled = false;
  }

  #disable(field) {
    field.style.display = 'none';
    field.querySelector('input, select').disabled = true;
  }
}
